(() => {
  "use strict";

  var e = {
      2: (e, t, n) => {
        n.d(t, {
          A: () => s
        });
        var r = n(601),
          i = n.n(r),
          o = n(314),
          a = n.n(o)()(i());
        a.push([e.id, '.tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;white-space:normal;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:"";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}', ""]);
        const s = a;
      },
      3: (e, t, n) => {
        n.d(t, {
          A: () => s
        });
        var r = n(601),
          i = n.n(r),
          o = n(314),
          a = n.n(o)()(i());
        a.push([e.id, ".tippy-box[data-theme~=material]{background-color:#505355;font-weight:600}.tippy-box[data-theme~=material][data-placement^=top]>.tippy-arrow:before{border-top-color:#505355}.tippy-box[data-theme~=material][data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:#505355}.tippy-box[data-theme~=material][data-placement^=left]>.tippy-arrow:before{border-left-color:#505355}.tippy-box[data-theme~=material][data-placement^=right]>.tippy-arrow:before{border-right-color:#505355}.tippy-box[data-theme~=material]>.tippy-backdrop{background-color:#505355}.tippy-box[data-theme~=material]>.tippy-svg-arrow{fill:#505355}", ""]);
        const s = a;
      },
      783: (e, t, n) => {
        n.d(t, {
          A: () => s
        });
        var r = n(601),
          i = n.n(r),
          o = n(314),
          a = n.n(o)()(i());
        a.push([e.id, "\n\n.cross {\n    position:absolute; \n    top: 10px; \n    right: 20px;\n    cursor: pointer;\n  }\n  .expand {\n    float:right;\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n  }\n\n.zoomIn {\n    position: absolute;\n    left: 20px;\n    top: 10px;\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n}\n\n.zoomOut {\n    position: absolute;\n    left: 20px;\n    top: 40px;\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n}\n\n.reset {\n    position: absolute;\n    left: 20px;\n    top: 70px;\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n}\n\n#confidenceStatement {\n  display: none;\n}\n\n.name {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  gap: 2px;\n}\n\n.more path {\n  stroke-width: 3;\n  stroke: #a92a2b;\n}\n\n.info {\n  width:16px;\n  height: 16px;\n}\n\n.info:hover {\n  cursor: pointer;\n}\n\nsvg .outerglow {\n  stroke-opacity: 0.4;\n  fill-opacity: 0.1;\n}\n\n.tippy-content p {\n  margin: 0;\n}\n\n.rhea-reaction-source {\n  position: relative;\n}\n\n", ""]);
        const s = a;
      },
      174: (e, t, n) => {
        n.d(t, {
          A: () => s
        });
        var r = n(601),
          i = n.n(r),
          o = n(314),
          a = n.n(o)()(i());
        a.push([e.id, "rhea-reaction {\n    display: flex;\n    flex-direction: column;\n    min-width: 100%;\n    justify-content: flex-start;\n    align-items: flex-start;\n    align-content: stretch;\n}\n\nrhea-reaction img {\n    width: 200px;\n    height: 200px;\n}\n\nrhea-reaction .rhea-reaction-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: left;\n}\n\nrhea-reaction-block {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 10px;\n}\n\nrhea-reaction-block.smallMolecule:hover {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\nrhea-reaction .residues {\n    display: flex;\n    flex-direction: row;\n    border: 1px grey dashed;\n    justify-content: center;\n}\n\nrhea-reaction-block .name {\n    margin-bottom: 10px;\n}\n\nrhea-reaction-block.and,\nrhea-reaction-block.none,\nrhea-reaction-block.forward,\nrhea-reaction-block.backward,\nrhea-reaction-block.bi,\nrhea-reaction-block.coefficient {\n    justify-content: center;\n}\n\nrhea-reaction .participantfooter {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\nrhea-reaction .filler {\n    flex-grow: 1;\n}\n\n.rhea-mapping-container2 {\n    width: 100%;\n}\n\nsvg.zoom {\n    cursor: pointer;\n}\n\n.more path {\n    stroke-width: 3;\n    stroke: #a92a2b;\n  }\n\n\n\n", ""]);
        const s = a;
      },
      943: (e, t, n) => {
        n.d(t, {
          A: () => s
        });
        var r = n(601),
          i = n.n(r),
          o = n(314),
          a = n.n(o)()(i());
        a.push([e.id, "\n.zoomedimagecontainer {\n    position: absolute;\n    width:100vw;\n    left:0;\n    top:0;\n    background: #FFFFFF;\n    z-index: 10;\n}\n\n.zoomedimage {\n    margin: auto auto;\n    display: block;\n    border: 1px solid black;\n}\nsvg.cross {\n    position: absolute;\n    top: 10px;\n    right: 20px;\n    cursor: pointer;\n}", ""]);
        const s = a;
      },
      445: (e, t, n) => {
        n.d(t, {
          A: () => p
        });
        var r = n(601),
          i = n.n(r),
          o = n(314),
          a = n.n(o),
          s = n(2),
          c = n(3),
          l = a()(i());
        l.i(s.A), l.i(c.A), l.push([e.id, ".tabs {\n    display: flex;\n}\n\n.tab {\n    padding: 0.5rem 0.75rem;\n    margin-right: 5px;\n    border-top-left-radius: 10px 10px;\n    cursor: pointer;\n    color: black;\n    background-color: rgba(250, 197, 191, 0.78);\n}\n\n.tab.selected {\n    background-color: #a92a2b;\n    color: white;\n    cursor: default;\n}\n\n.tabpanel {\n    padding: 10px;\n    border: 2px solid #a92a2b;\n    overflow: auto;\n}\n\n.tabpanel:not(.selected) {\n    display: none;\n}\n\nsvg {\n    height: inherit;\n}\n\na.icon_link {\n    text-decoration: none;\n}\n\n\n.more:hover {\n    cursor: pointer;\n    stroke: #F1D6C8; \n}\n\n.externallink:hover {\n    stroke: #F1D6C8; \n}\n\n.tippy-content ul {\n    list-style: none;\n    margin: 10px auto;\n    text-align: left;\n    padding: 0px;\n}\n\n.tippy-content a {\n    color: #F1D6C8;\n    \n}\n\n.tippy-content svg {\n    stroke: #ffffff;\n}\n\n.tippy-content {\n    text-align: left;\n    font-weight: 500;\n}\n\n\n\n\n\n", ""]);
        const p = l;
      },
      314: e => {
        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var n = "",
                r = void 0 !== t[5];
              return t[4] && (n += "@supports (".concat(t[4], ") {")), t[2] && (n += "@media ".concat(t[2], " {")), r && (n += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), n += e(t), r && (n += "}"), t[2] && (n += "}"), t[4] && (n += "}"), n;
            }).join("");
          }, t.i = function (e, n, r, i, o) {
            "string" == typeof e && (e = [[null, e, void 0]]);
            var a = {};
            if (r) for (var s = 0; s < this.length; s++) {
              var c = this[s][0];
              null != c && (a[c] = !0);
            }
            for (var l = 0; l < e.length; l++) {
              var p = [].concat(e[l]);
              r && a[p[0]] || (void 0 !== o && (void 0 === p[5] || (p[1] = "@layer".concat(p[5].length > 0 ? " ".concat(p[5]) : "", " {").concat(p[1], "}")), p[5] = o), n && (p[2] ? (p[1] = "@media ".concat(p[2], " {").concat(p[1], "}"), p[2] = n) : p[2] = n), i && (p[4] ? (p[1] = "@supports (".concat(p[4], ") {").concat(p[1], "}"), p[4] = i) : p[4] = "".concat(i)), t.push(p));
            }
          }, t;
        };
      },
      601: e => {
        e.exports = function (e) {
          return e[1];
        };
      }
    },
    t = {};
  function n(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var o = t[r] = {
      id: r,
      exports: {}
    };
    return e[r](o, o.exports, n), o.exports;
  }
  n.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, {
      a: t
    }), t;
  }, n.d = (e, t) => {
    for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
  var r = n(174),
    i = n(943);
  const o = "https://www.rhea-db.org";
  function a(e, t, n = !1) {
    return `<div class="rhea-reaction-source">\n              <span>RHEA:${e}</span>\n              <a class="icon_link" href="${function (e, t) {
      return e + `/rhea/${t}`;
    }(t, e)}" style="display:inline"><svg class="icon externalLink" fill="#000000" width="0.8rem" height="0.8rem" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14.21 1.5H10v1.25h3.08L7.9 7.21l.82 1 5.53-4.77V7h1.25V2.79a1.29 1.29 0 0 0-1.29-1.29z"/><path d="M12.25 13.25H1.75v-8.5H7.5V3.5h-6a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4h-1.25z"/></svg>\n              </a>\n              ${n ? '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n\x3c!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --\x3e\n<svg class="icon zoomIn" width="1rem" height="1rem" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n    \n    <title>zoom-in</title>\n    <desc>Created with Sketch Beta.</desc>\n    <defs>\n\n</defs>\n    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-308.000000, -1139.000000)" fill="#000000">\n            <path d="M321.46,1163.45 C315.17,1163.45 310.07,1158.44 310.07,1152.25 C310.07,1146.06 315.17,1141.04 321.46,1141.04 C327.75,1141.04 332.85,1146.06 332.85,1152.25 C332.85,1158.44 327.75,1163.45 321.46,1163.45 L321.46,1163.45 Z M339.688,1169.25 L331.429,1161.12 C333.592,1158.77 334.92,1155.67 334.92,1152.25 C334.92,1144.93 328.894,1139 321.46,1139 C314.026,1139 308,1144.93 308,1152.25 C308,1159.56 314.026,1165.49 321.46,1165.49 C324.672,1165.49 327.618,1164.38 329.932,1162.53 L338.225,1170.69 C338.629,1171.09 339.284,1171.09 339.688,1170.69 C340.093,1170.3 340.093,1169.65 339.688,1169.25 L339.688,1169.25 Z M326.519,1151.41 L322.522,1151.41 L322.522,1147.41 C322.522,1146.85 322.075,1146.41 321.523,1146.41 C320.972,1146.41 320.524,1146.85 320.524,1147.41 L320.524,1151.41 L316.529,1151.41 C315.978,1151.41 315.53,1151.59 315.53,1152.14 C315.53,1152.7 315.978,1153.41 316.529,1153.41 L320.524,1153.41 L320.524,1157.41 C320.524,1157.97 320.972,1158.41 321.523,1158.41 C322.075,1158.41 322.522,1157.97 322.522,1157.41 L322.522,1153.41 L326.519,1153.41 C327.07,1153.41 327.518,1152.96 327.518,1152.41 C327.518,1151.86 327.07,1151.41 326.519,1151.41 L326.519,1151.41 Z" id="zoom-in" sketch:type="MSShapeGroup">\n\n</path>\n        </g>\n    </g>\n</svg>\n\n\n' : ""}\n          </div>`;
  }
  function s(e) {
    return `\n    <div class='name'>\n        <small>${decodeURI(e.htmlname)} ${e.location ? `(${e.location})` : ""}</small>\n    </div>\n    `;
  }
  function c(e, t = {}) {
    let n = t.polymer ? t.polymer.htmlname : e.htmlname ? e.htmlname : e.label;
    return `<div class="name">\n            <span>${decodeURI(n)}</span>\n            ${e.location ? `(${e.location})` : ""}\n            <span class='more' data-id="${e.id}"><?xml version="1.0" encoding="utf-8"?>\n<svg width="0.8rem" height="0.8rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M5.5 5L11.7929 11.2929C12.1834 11.6834 12.1834 12.3166 11.7929 12.7071L5.5 19" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n<path d="M13.5 5L19.7929 11.2929C20.1834 11.6834 20.1834 12.3166 19.7929 12.7071L13.5 19" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>\n\x3c!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools\n<svg fill="#000000" width="0.8rem" height="0.8rem" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n\n<g data-name="Layer 2">\n\n<g data-name="arrow-ios-forward">\n\n<rect width="24" height="24" transform="rotate(-90 12 12)" opacity="0"/>\n\n<path d="M10 19a1 1 0 0 1-.64-.23 1 1 0 0 1-.13-1.41L13.71 12 9.39 6.63a1 1 0 0 1 .15-1.41 1 1 0 0 1 1.46.15l4.83 6a1 1 0 0 1 0 1.27l-5 6A1 1 0 0 1 10 19z"/>\n\n</g>\n\n</g>\n\n</svg>--\x3e</span>\n        </div>`;
  }
  const l = function (e, t) {
      return `\n        <p>Molecule CHEBI:${e}</p>\n        <ul>\n            <li><a href="${function (e) {
        return `https://www.ebi.ac.uk/chebi/searchId.do?chebiId=CHEBI:${e}`;
      }(e)}">See the description</a> of this molecule in <b>ChEBI</b>.</li>\n            <li><a href="${function (e, t) {
        return `${e}/structuresearch/?query=${t}&landing=true`;
      }(t, `chebi:${e}`)}">Search similar molecules</a> in <b>Rhea</b>.</li>\n            <li><a href="${t}/rhea/?query=chebi:${e}">Search chemical reactions</a> in <b>Rhea</b> for this molecule.</li>\n            <li><a href="${n = `chebi:${e}`, `https://www.uniprot.org/uniprotkb/?query=${n}`}">Search proteins</a> in <b>UniProtKB</b> for this molecule.</li>\n        </ul>\n    `;
      var n;
    },
    p = {
      forward: "=>",
      backward: "<=",
      bi: "<=>",
      none: "="
    },
    d = {
      SMALL_MOLECULE: "smallMolecule",
      GENERIC_COMPOUND: "genericcomp",
      POLYMER: "polymer"
    };
  class u extends HTMLElement {
    constructor() {
      super(), this.rheaURL = this.hasAttribute("usehost") ? this.getAttribute("usehost") : o, this.imageHost = this.hasAttribute("imagehost") ? this.getAttribute("imagehost") : this.rheaURL, this.shownewchebi = this.hasAttribute("shownewchebi"), this._reaction = {}, this._rheaid = "";
    }
    get reaction() {
      return this._reaction;
    }
    set reaction(e) {
      0 == e.length ? console.log("nothing to render") : (this._reaction = e, this.render(e));
    }
    set rheaid(e) {
      this._rheaid = e, this.renderWithId(e);
    }
    get rheaid() {
      return this._rheaid;
    }
    attributeChangedCallback(e, t, n) {
      if (t !== n && "rheaid" === e) {
        let e = n.toLowerCase();
        e.startsWith("rhea:") && (e = e.subString(5)), this.renderWithId(e);
      }
    }
    static get observedAttributes() {
      return ["rheaid"];
    }
    async renderWithId(e) {
      let t = await fetch((n = e, r = this.rheaURL, `${r}/rhea/${n}/json`));
      var n, r;
      t = await t.json(), this.reaction = t;
    }
    async render(e) {
      if (null == e || 0 == Object.keys(e).length) return this.renderDataError();
      this._rheaid = e.id;
      let t = {
        nosource: this.hasAttribute("nosource"),
        showids: this.hasAttribute("showids"),
        formula: this.hasAttribute("formula"),
        charge: this.hasAttribute("charge"),
        smiles: this.hasAttribute("smiles"),
        inchikey: this.hasAttribute("inchikey"),
        structuresearch: this.hasAttribute("structuresearch"),
        rheaurl: this.rheaURL,
        imagehost: this.imageHost
      };
      this.innerHTML = `\n            <style>${r.A}</style>\n            ${t.nosource ? "" : a(e.id, this.rheaURL)}\n            <div class="rhea-reaction-container">\n                ${this.getList("left", e.left)}\n                    <rhea-reaction-block ${this.shownewchebi ? "shownewchebi" : ""} imagehost="${this.imageHost}" class="${e.direction}">${p[e.direction]}</rhea-reaction-block>\n                ${this.getList("right", e.right)}\n            </div>`, this.querySelectorAll("rhea-reaction-block.participant").forEach(n => {
        let r = n.getAttribute("index").split("-"),
          i = r[0];
        r = r[1], n.removeAttribute("index"), n.setParticipant(e[i][r], this.hasAttribute("zoom"), t);
      }), this.hasAttribute("zoom") && Array.from(this.querySelectorAll("svg.zoom")).forEach(e => e.addEventListener("click", e => {
        if (!e.target.hasAttribute("data-id")) return;
        let t = e.target.getAttribute("data-id");
        document.querySelector("body").insertAdjacentHTML("afterbegin", `\n                        <div class='rhea-zoomed-image'>\n                            <style>${i.A}</style>\n                            <div class="zoomedimagecontainer" >\n                                <?xml version="1.0" encoding="utf-8"?>\n\x3c!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --\x3e\n<svg fill="#000000" class="icon cross" width="25px" height="25px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">\n<title>cancel2</title>\n<path d="M19.587 16.001l6.096 6.096c0.396 0.396 0.396 1.039 0 1.435l-2.151 2.151c-0.396 0.396-1.038 0.396-1.435 0l-6.097-6.096-6.097 6.096c-0.396 0.396-1.038 0.396-1.434 0l-2.152-2.151c-0.396-0.396-0.396-1.038 0-1.435l6.097-6.096-6.097-6.097c-0.396-0.396-0.396-1.039 0-1.435l2.153-2.151c0.396-0.396 1.038-0.396 1.434 0l6.096 6.097 6.097-6.097c0.396-0.396 1.038-0.396 1.435 0l2.151 2.152c0.396 0.396 0.396 1.038 0 1.435l-6.096 6.096z"></path>\n</svg>\n                                <img class="zoomedimage" width="500px" height="500px" src="${this.imageHost}/chebi/${t}"/>\n                            </div>\n                        </div>\n                        `), document.querySelector("svg.cross").addEventListener("click", e => document.querySelector(".rhea-zoomed-image").remove());
      })), this.dispatchRenderComplete();
    }
    dispatchRenderComplete(e = "") {
      let t = new CustomEvent("rendered-rhea-reaction", {
        detail: {
          error: e
        },
        bubbles: !0
      });
      this.dispatchEvent(t);
    }
    renderDataError() {
      this.innerHTML = "<p>Reaction data could not be loaded.</p>", this.dispatchRenderComplete("Reaction data could not be loaded.");
    }
    getList(e, t) {
      return t.map((n, r) => {
        let i = r != t.length - 1;
        return `\n                ${n.coff ? `<rhea-reaction-block class="coefficient" >${n.coff}</rhea-reaction-block>` : ""}\n                <rhea-reaction-block ${this.shownewchebi ? "shownewchebi" : ""} imagehost="${this.imageHost}" class="participant ${d[n.type]}" index="${e}-${r}"></rhea-reaction-block>\n                ${i ? `<rhea-reaction-block ${this.shownewchebi ? "shownewchebi" : ""} class="and">+</rhea-reaction-block>` : ""}`;
      }).map(e => e.trim()).join("");
    }
  }
  class h extends HTMLElement {
    constructor() {
      super(), this.shownewchebi = this.hasAttribute("shownewchebi"), this.imageHost = this.hasAttribute("imagehost") ? this.getAttribute("imagehost") : "";
    }
    smallMolecule(e, t = "", n) {
      "" != t && (e.idtoshow = t);
      let r = c(e, n),
        i = e.thumbnail;
      return i = n.polymer ? this.shownewchebi && n.polymer.newthumbnail ? n.polymer.newthumbnail : n.polymer.thumbnail : this.shownewchebi && e.newthumbnail ? e.newthumbnail : i, `<img width="200px" height="200px" alt="No structure information present" src="${this.imageHost}${i}"></img> ${r}`;
    }
    setParticipant(e, t, n) {
      switch (e.type) {
        case "SMALL_MOLECULE":
          this.innerHTML = this.smallMolecule(e, n.showids ? `CHEBI:${e.id}` : "", n);
          break;
        case "POLYMER":
          let r = {
            ...n,
            polymer: {
              thumbnail: e.thumbnail,
              newthumbnail: e.newthumbnail,
              htmlname: e.htmlname ? e.htmlname : e.label
            }
          };
          this.innerHTML = this.smallMolecule(e.underlyingChebi, n.showids ? `RHEA-COMP:${e.id}` : "", r);
          break;
        case "GENERIC_COMPOUND":
          this.innerHTML = `\n                <div class="residues">${e.reactivePart.map((e, t) => `<rhea-reaction-block ${this.shownewchebi ? "shownewchebi" : ""} imagehost="${this.imageHost}" class="participant ${d[e.type]}" index="${t}"></rhea-reaction-block>`).join("")}\n                </div>\n                <small> of </small>${s(e)}`, this.querySelectorAll("rhea-reaction-block").forEach(r => {
            let i = r.getAttribute("index");
            r.removeAttribute("index");
            let o = {
              ...n,
              generic: {}
            };
            r.setParticipant(e.reactivePart[i], t, o);
          });
          break;
        default:
          return "";
      }
    }
  }
  var f = n(783);
  class m extends HTMLElement {
    constructor() {
      super(), this.rheaURL = this.hasAttribute("usehost") ? this.getAttribute("usehost") : o, this.imageHost = this.hasAttribute("imagehost") ? this.getAttribute("imagehost") : this.rheaURL, this._reaction = {}, this._rheaid = "";
    }
    get reaction() {
      return this._reaction;
    }
    set reaction(e) {
      this._reaction = e, this.render(e);
    }
    set rheaid(e) {
      this._rheaid = e, this.renderWithId(e);
    }
    get rheaid() {
      return this._rheaid;
    }
    attributeChangedCallback(e, t, n) {
      if (t !== n && "rheaid" === e) {
        let e = n.toLowerCase();
        e.startsWith("rhea:") && (e = e.subString(5)), this.renderWithId(e);
      }
    }
    static get observedAttributes() {
      return ["rheaid"];
    }
    async renderWithId(e) {
      let t = await fetch(`${this.rheaURL}/rhea/${e}/json`);
      this.reaction = await t.json();
    }
    smallMolNameHTML(e, t) {
      return `<div class='name'>\n                <a href='https://www.ebi.ac.uk/chebi/searchId.do?chebiId=CHEBI:${e}'> \n                    ${t} \n                </a>\n                <a class='participantId'>\n                  CHEBI:${e}\n                </a>\n            </div>`;
    }
    prepareJSONtoRenderChebi(e) {
      let t = JSON.parse(JSON.stringify(e));
      return this.showIds() && (t.idtoshow = "CHEBI:" + e.id), t.showZoom = !1, t;
    }
    fetchChebisFromJson() {
      return [...this.reaction.left, ...this.reaction.right].flatMap(e => {
        let t = e.coff ? parseInt(e.coff) : 1,
          n = [];
        for (let r = 0; r < t; r++) n.push({
          ...e
        });
        return n;
      }).flatMap(e => {
        switch (e.type) {
          case "GENERIC_COMPOUND":
            return e.reactivePart.map(t => {
              let n = this.prepareJSONtoRenderChebi(t);
              return {
                id: "CHEBI:" + t.id + "_RHEA-COMP:" + e.id,
                htmlname: c(n) + `<small> ${n.position ? `at position ${n.position}` : ""} of </small>` + s(e),
                used: !1
              };
            });
          case "SMALL_MOLECULE":
            let t = this.prepareJSONtoRenderChebi(e);
            return {
              id: "CHEBI:" + e.id,
              htmlname: c(t),
              used: !1
            };
          default:
            return {
              id: e.id,
              htmlname: "",
              used: !1
            };
        }
      });
    }
    reRenderSVG() {
      this.innerHTML = "", this.render(this.reaction, !0);
    }
    showIds() {
      return this.hasAttribute("showids");
    }
    renderPolymerError(e) {
      this.innerHTML = "<p>No atom map available for this reaction.</p>", this.dispatchRenderComplete(e, "No atom map available for this reaction.");
    }
    renderNoSvgError(e) {
      this.innerHTML = "<p>No atom map available for this reaction.</p>", this.dispatchRenderComplete(e, "No atom map available for this reaction.");
    }
    renderDataError(e) {
      this.innerHTML = "<p>Reaction data could not be loaded.</p>", this.dispatchRenderComplete(e, "Reaction data could not be loaded.");
    }
    async render(e, t = !1) {
      if (null == e || 0 == Object.keys(e).length) return this.renderDataError(t);
      if (this._rheaid = e.id, 0 != [...e.left, ...e.right].map(e => e.type).filter(e => "POLYMER" == e).length) return this.renderPolymerError(t);
      let n = await fetch(this.imageHost + "/rhea/" + e.id + "/svg");
      if (!n.ok) return this.renderNoSvgError(t);
      let r = parseFloat(/(.+)px/.exec(window.getComputedStyle(this.parentElement).width)[1]),
        i = await n.text(),
        o = parseFloat(/width=\'(.+?)px\'/.exec(i)[1]),
        s = parseFloat(/height=\'(.+?)px\'/.exec(i)[1]),
        c = 100 * Math.ceil(s / 100);
      i = i.replace(/<svg/, `<svg data-width="${o}" data-height="${s}" data-parent-width="${r}"`), i = i.replace(/width=\'(.+?)px\'/, `width="${r}"`), i = i.replace(/height=\'(.+?)px\'/, "height=" + r * (s / o)), this.innerHTML = `\n          ${this.hasAttribute("nosource") ? "" : a(e.id, this.rheaURL, !1)}\n          <span>\n            <label for="atomcolors">Color atoms</label>\n            <input type="checkbox" checked name="atomcolors" id="atomcolors">,\n          </span>\n          <span>\n            <label for="atomnumbers">Number atoms</label>\n            <input type="checkbox" checked name="atomnumbers" id="atomnumbers">,\n          </span>\n          <span>\n            <span id="confidenceStatement">Confidence = <span id="confidence"></span>\n            <sup><?xml version="1.0" ?>\n\x3c!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --\x3e\n<svg class="icon info" fill="#000000" width="20px" height="20px" viewBox="0 0 31.925 31.925" xmlns="http://www.w3.org/2000/svg">\n    <g transform="translate(-673.321 -514.099)">\n        <path d="M689.284,516.1a13.962,13.962,0,1,1-13.963,13.962A13.977,13.977,0,0,1,689.284,516.1m0-2a15.962,15.962,0,1,0,15.962,15.962A15.962,15.962,0,0,0,689.284,514.1Z"/>\n        <path d="M687.65,531.612a2.374,2.374,0,0,1,.49-1.433,9.248,9.248,0,0,1,1.443-1.483,10.084,10.084,0,0,0,1.321-1.371,1.993,1.993,0,0,0,.367-1.2,1.953,1.953,0,0,0-1.982-2,2.073,2.073,0,0,0-1.419.543,3.56,3.56,0,0,0-.954,1.582l-2.152-.939a5.027,5.027,0,0,1,1.724-2.657,4.632,4.632,0,0,1,2.9-.926,4.959,4.959,0,0,1,2.287.531,4.154,4.154,0,0,1,1.651,1.5,3.979,3.979,0,0,1,.611,2.175,3.681,3.681,0,0,1-.538,1.965,8.76,8.76,0,0,1-1.638,1.865,13.792,13.792,0,0,0-1.359,1.322,1.536,1.536,0,0,0-.379,1,2.868,2.868,0,0,0,.1.667h-2.2A2.74,2.74,0,0,1,687.65,531.612Zm1.468,6.969a1.855,1.855,0,0,1-1.357-.543,1.831,1.831,0,0,1-.551-1.359,1.875,1.875,0,0,1,.551-1.372,1.835,1.835,0,0,1,1.357-.556,1.868,1.868,0,0,1,1.908,1.928,1.833,1.833,0,0,1-.549,1.359A1.863,1.863,0,0,1,689.118,538.581Z"/>\n    </g>\n</svg></sup>\n            </span> \n          </span>\n          <div class="rhea-mapping-container2" style="height:${c}px">\n          ${i}\n          </div>`;
      let l = this.fetchChebisFromJson(),
        p = this.querySelector(".rhea-mapping-container2"),
        d = p.querySelector("svg"),
        u = p.getBoundingClientRect().width,
        h = d.getBoundingClientRect().x,
        m = Array.from(d.querySelectorAll("g.mol")).map(e => {
          let {
              x: t,
              width: n
            } = e.getBoundingClientRect(),
            r = Array.from(e.classList).filter(e => -1 != e.indexOf("CHEBI")),
            i = l.filter(e => e.id == r).filter(e => !e.used),
            o = i.length > 0 ? i[0].htmlname : "";
          return i[0].used = !0, {
            x: t - h,
            width: n,
            title: o
          };
        }),
        g = [],
        b = 0,
        v = 0;
      for (let e = 0; e < m.length; e++) {
        let t = m[e],
          n = 0 == e ? {
            x: 0,
            width: 0
          } : m[e - 1],
          r = t.x - n.x - n.width,
          i = r / u * 100;
        v += i, g.push({
          percet: i,
          html: `<div style="grid-area:m${b};margin:auto"></div>`
        }), b++, r = t.width, i = r / u * 100, v += i, g.push({
          percet: i,
          html: `<div class="name_container" style="grid-area:m${b};margin:auto;text-align:center">\n                  ${t.title}\n                </div>`
        }), b++;
      }
      v < 100 && g.push({
        percet: 100 - v,
        html: `<div class="name_container" style="grid-area:m${b};margin:auto"></div>`
      }), p.insertAdjacentHTML("beforeend", g.map(e => e.html).join(""));
      let w = g.map(e => e.percet + "%").join(" ");
      console.log(w);
      let y = ["'" + g.map(e => "image").join(" ") + "'", "'" + g.map((e, t) => `m${t}`).join(" ") + "'"].join(" ");
      d.style.gridArea = "image";
      let x = `<style> \n        .rhea-mapping-container2 \n        { \n        grid-template: ${y}; \n        grid-template-columns : ${w};\n        \n        } \n        .name_container {\n          width: 100%;\n          height: 100%;\n          margin-top: 10px;\n          word-wrap: break-word;\n          font-size: 12px;\n        }\n        ${f.A}\n        </style>`;
      p.insertAdjacentHTML("beforeend", x), p.style.display = "grid";
      let A = (e, t, n) => {
        if (e) t.setAttribute(n, t.getAttribute(`data-${n}`)), t.removeAttribute(n + "-opacity");else {
          let e = t.getAttribute(n);
          t.setAttribute(n, "#ffffff"), t.setAttribute(n + "-opacity", "0"), t.setAttribute(`data-${n}`, e);
        }
      };
      this.setConfidenceLevel(p), this.querySelector("#atomnumbers").addEventListener("click", e => {
        Array.from(p.querySelectorAll("path:not(.atom, .bond)")).filter(e => !e.parentNode.matches("g.atom") && !e.parentNode.matches("g[stroke-linecap]")).forEach(t => A(e.target.checked, t, "fill"));
      }), this.querySelector("#atomcolors").addEventListener("click", e => {
        Array.from(p.querySelectorAll("g.outerglow > *")).forEach(t => {
          t.matches("ellipse") ? A(e.target.checked, t, "fill") : t.matches("path") || t.matches("line") ? A(e.target.checked, t, "stroke") : console.error("Error while toggling colors");
        }), Array.from(this.querySelectorAll(".outerglow:not(g)")).forEach(t => {
          A(e.target.checked, t, "stroke");
        });
      }), this.querySelector("#atomnumbers").click(), this.dispatchRenderComplete(t);
    }
    dispatchRenderComplete(e = !1, t = "") {
      this.dispatchEvent(new CustomEvent("rendered-rhea-atommap", {
        detail: {
          error: t,
          reRender: e
        },
        bubbles: !0
      }));
    }
    setConfidenceLevel(e) {
      let t = e.querySelector("svg");
      if (t.hasAttribute("data-confidence")) {
        let e = t.getAttribute("data-confidence");
        this.querySelector("#confidence").innerHTML = e, this.querySelector("#confidenceStatement").style.display = "inline";
      }
    }
  }
  var g = n(445);
  function b(e) {
    if (null == e) return window;
    if ("[object Window]" !== e.toString()) {
      var t = e.ownerDocument;
      return t && t.defaultView || window;
    }
    return e;
  }
  function v(e) {
    return e instanceof b(e).Element || e instanceof Element;
  }
  function w(e) {
    return e instanceof b(e).HTMLElement || e instanceof HTMLElement;
  }
  function y(e) {
    return "undefined" != typeof ShadowRoot && (e instanceof b(e).ShadowRoot || e instanceof ShadowRoot);
  }
  var x = Math.max,
    A = Math.min,
    E = Math.round;
  function L() {
    var e = navigator.userAgentData;
    return null != e && e.brands && Array.isArray(e.brands) ? e.brands.map(function (e) {
      return e.brand + "/" + e.version;
    }).join(" ") : navigator.userAgent;
  }
  function O() {
    return !/^((?!chrome|android).)*safari/i.test(L());
  }
  function k(e, t, n) {
    void 0 === t && (t = !1), void 0 === n && (n = !1);
    var r = e.getBoundingClientRect(),
      i = 1,
      o = 1;
    t && w(e) && (i = e.offsetWidth > 0 && E(r.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && E(r.height) / e.offsetHeight || 1);
    var a = (v(e) ? b(e) : window).visualViewport,
      s = !O() && n,
      c = (r.left + (s && a ? a.offsetLeft : 0)) / i,
      l = (r.top + (s && a ? a.offsetTop : 0)) / o,
      p = r.width / i,
      d = r.height / o;
    return {
      width: p,
      height: d,
      top: l,
      right: c + p,
      bottom: l + d,
      left: c,
      x: c,
      y: l
    };
  }
  function C(e) {
    var t = b(e);
    return {
      scrollLeft: t.pageXOffset,
      scrollTop: t.pageYOffset
    };
  }
  function T(e) {
    return e ? (e.nodeName || "").toLowerCase() : null;
  }
  function M(e) {
    return ((v(e) ? e.ownerDocument : e.document) || window.document).documentElement;
  }
  function S(e) {
    return k(M(e)).left + C(e).scrollLeft;
  }
  function R(e) {
    return b(e).getComputedStyle(e);
  }
  function $(e) {
    var t = R(e),
      n = t.overflow,
      r = t.overflowX,
      i = t.overflowY;
    return /auto|scroll|overlay|hidden/.test(n + i + r);
  }
  function j(e, t, n) {
    void 0 === n && (n = !1);
    var r,
      i,
      o = w(t),
      a = w(t) && function (e) {
        var t = e.getBoundingClientRect(),
          n = E(t.width) / e.offsetWidth || 1,
          r = E(t.height) / e.offsetHeight || 1;
        return 1 !== n || 1 !== r;
      }(t),
      s = M(t),
      c = k(e, a, n),
      l = {
        scrollLeft: 0,
        scrollTop: 0
      },
      p = {
        x: 0,
        y: 0
      };
    return (o || !o && !n) && (("body" !== T(t) || $(s)) && (l = (r = t) !== b(r) && w(r) ? {
      scrollLeft: (i = r).scrollLeft,
      scrollTop: i.scrollTop
    } : C(r)), w(t) ? ((p = k(t, !0)).x += t.clientLeft, p.y += t.clientTop) : s && (p.x = S(s))), {
      x: c.left + l.scrollLeft - p.x,
      y: c.top + l.scrollTop - p.y,
      width: c.width,
      height: c.height
    };
  }
  function H(e) {
    var t = k(e),
      n = e.offsetWidth,
      r = e.offsetHeight;
    return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
      x: e.offsetLeft,
      y: e.offsetTop,
      width: n,
      height: r
    };
  }
  function D(e) {
    return "html" === T(e) ? e : e.assignedSlot || e.parentNode || (y(e) ? e.host : null) || M(e);
  }
  function I(e) {
    return ["html", "body", "#document"].indexOf(T(e)) >= 0 ? e.ownerDocument.body : w(e) && $(e) ? e : I(D(e));
  }
  function q(e, t) {
    var n;
    void 0 === t && (t = []);
    var r = I(e),
      i = r === (null == (n = e.ownerDocument) ? void 0 : n.body),
      o = b(r),
      a = i ? [o].concat(o.visualViewport || [], $(r) ? r : []) : r,
      s = t.concat(a);
    return i ? s : s.concat(q(D(a)));
  }
  function P(e) {
    return ["table", "td", "th"].indexOf(T(e)) >= 0;
  }
  function _(e) {
    return w(e) && "fixed" !== R(e).position ? e.offsetParent : null;
  }
  function B(e) {
    for (var t = b(e), n = _(e); n && P(n) && "static" === R(n).position;) n = _(n);
    return n && ("html" === T(n) || "body" === T(n) && "static" === R(n).position) ? t : n || function (e) {
      var t = /firefox/i.test(L());
      if (/Trident/i.test(L()) && w(e) && "fixed" === R(e).position) return null;
      var n = D(e);
      for (y(n) && (n = n.host); w(n) && ["html", "body"].indexOf(T(n)) < 0;) {
        var r = R(n);
        if ("none" !== r.transform || "none" !== r.perspective || "paint" === r.contain || -1 !== ["transform", "perspective"].indexOf(r.willChange) || t && "filter" === r.willChange || t && r.filter && "none" !== r.filter) return n;
        n = n.parentNode;
      }
      return null;
    }(e) || t;
  }
  var N = "top",
    U = "bottom",
    V = "right",
    W = "left",
    z = "auto",
    F = [N, U, V, W],
    G = "start",
    J = "end",
    Z = "viewport",
    Y = "popper",
    X = F.reduce(function (e, t) {
      return e.concat([t + "-" + G, t + "-" + J]);
    }, []),
    K = [].concat(F, [z]).reduce(function (e, t) {
      return e.concat([t, t + "-" + G, t + "-" + J]);
    }, []),
    Q = ["beforeRead", "read", "afterRead", "beforeMain", "main", "afterMain", "beforeWrite", "write", "afterWrite"];
  function ee(e) {
    var t = new Map(),
      n = new Set(),
      r = [];
    function i(e) {
      n.add(e.name), [].concat(e.requires || [], e.requiresIfExists || []).forEach(function (e) {
        if (!n.has(e)) {
          var r = t.get(e);
          r && i(r);
        }
      }), r.push(e);
    }
    return e.forEach(function (e) {
      t.set(e.name, e);
    }), e.forEach(function (e) {
      n.has(e.name) || i(e);
    }), r;
  }
  var te = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
  };
  function ne() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
    return !t.some(function (e) {
      return !(e && "function" == typeof e.getBoundingClientRect);
    });
  }
  function re(e) {
    void 0 === e && (e = {});
    var t = e,
      n = t.defaultModifiers,
      r = void 0 === n ? [] : n,
      i = t.defaultOptions,
      o = void 0 === i ? te : i;
    return function (e, t, n) {
      void 0 === n && (n = o);
      var i,
        a,
        s = {
          placement: "bottom",
          orderedModifiers: [],
          options: Object.assign({}, te, o),
          modifiersData: {},
          elements: {
            reference: e,
            popper: t
          },
          attributes: {},
          styles: {}
        },
        c = [],
        l = !1,
        p = {
          state: s,
          setOptions: function (n) {
            var i = "function" == typeof n ? n(s.options) : n;
            d(), s.options = Object.assign({}, o, s.options, i), s.scrollParents = {
              reference: v(e) ? q(e) : e.contextElement ? q(e.contextElement) : [],
              popper: q(t)
            };
            var a,
              l,
              u = function (e) {
                var t = ee(e);
                return Q.reduce(function (e, n) {
                  return e.concat(t.filter(function (e) {
                    return e.phase === n;
                  }));
                }, []);
              }((a = [].concat(r, s.options.modifiers), l = a.reduce(function (e, t) {
                var n = e[t.name];
                return e[t.name] = n ? Object.assign({}, n, t, {
                  options: Object.assign({}, n.options, t.options),
                  data: Object.assign({}, n.data, t.data)
                }) : t, e;
              }, {}), Object.keys(l).map(function (e) {
                return l[e];
              })));
            return s.orderedModifiers = u.filter(function (e) {
              return e.enabled;
            }), s.orderedModifiers.forEach(function (e) {
              var t = e.name,
                n = e.options,
                r = void 0 === n ? {} : n,
                i = e.effect;
              if ("function" == typeof i) {
                var o = i({
                  state: s,
                  name: t,
                  instance: p,
                  options: r
                });
                c.push(o || function () {});
              }
            }), p.update();
          },
          forceUpdate: function () {
            if (!l) {
              var e = s.elements,
                t = e.reference,
                n = e.popper;
              if (ne(t, n)) {
                s.rects = {
                  reference: j(t, B(n), "fixed" === s.options.strategy),
                  popper: H(n)
                }, s.reset = !1, s.placement = s.options.placement, s.orderedModifiers.forEach(function (e) {
                  return s.modifiersData[e.name] = Object.assign({}, e.data);
                });
                for (var r = 0; r < s.orderedModifiers.length; r++) if (!0 !== s.reset) {
                  var i = s.orderedModifiers[r],
                    o = i.fn,
                    a = i.options,
                    c = void 0 === a ? {} : a,
                    d = i.name;
                  "function" == typeof o && (s = o({
                    state: s,
                    options: c,
                    name: d,
                    instance: p
                  }) || s);
                } else s.reset = !1, r = -1;
              }
            }
          },
          update: (i = function () {
            return new Promise(function (e) {
              p.forceUpdate(), e(s);
            });
          }, function () {
            return a || (a = new Promise(function (e) {
              Promise.resolve().then(function () {
                a = void 0, e(i());
              });
            })), a;
          }),
          destroy: function () {
            d(), l = !0;
          }
        };
      if (!ne(e, t)) return p;
      function d() {
        c.forEach(function (e) {
          return e();
        }), c = [];
      }
      return p.setOptions(n).then(function (e) {
        !l && n.onFirstUpdate && n.onFirstUpdate(e);
      }), p;
    };
  }
  var ie = {
    passive: !0
  };
  function oe(e) {
    return e.split("-")[0];
  }
  function ae(e) {
    return e.split("-")[1];
  }
  function se(e) {
    return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
  }
  function ce(e) {
    var t,
      n = e.reference,
      r = e.element,
      i = e.placement,
      o = i ? oe(i) : null,
      a = i ? ae(i) : null,
      s = n.x + n.width / 2 - r.width / 2,
      c = n.y + n.height / 2 - r.height / 2;
    switch (o) {
      case N:
        t = {
          x: s,
          y: n.y - r.height
        };
        break;
      case U:
        t = {
          x: s,
          y: n.y + n.height
        };
        break;
      case V:
        t = {
          x: n.x + n.width,
          y: c
        };
        break;
      case W:
        t = {
          x: n.x - r.width,
          y: c
        };
        break;
      default:
        t = {
          x: n.x,
          y: n.y
        };
    }
    var l = o ? se(o) : null;
    if (null != l) {
      var p = "y" === l ? "height" : "width";
      switch (a) {
        case G:
          t[l] = t[l] - (n[p] / 2 - r[p] / 2);
          break;
        case J:
          t[l] = t[l] + (n[p] / 2 - r[p] / 2);
      }
    }
    return t;
  }
  var le = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
  };
  function pe(e) {
    var t,
      n = e.popper,
      r = e.popperRect,
      i = e.placement,
      o = e.variation,
      a = e.offsets,
      s = e.position,
      c = e.gpuAcceleration,
      l = e.adaptive,
      p = e.roundOffsets,
      d = e.isFixed,
      u = a.x,
      h = void 0 === u ? 0 : u,
      f = a.y,
      m = void 0 === f ? 0 : f,
      g = "function" == typeof p ? p({
        x: h,
        y: m
      }) : {
        x: h,
        y: m
      };
    h = g.x, m = g.y;
    var v = a.hasOwnProperty("x"),
      w = a.hasOwnProperty("y"),
      y = W,
      x = N,
      A = window;
    if (l) {
      var L = B(n),
        O = "clientHeight",
        k = "clientWidth";
      L === b(n) && "static" !== R(L = M(n)).position && "absolute" === s && (O = "scrollHeight", k = "scrollWidth"), (i === N || (i === W || i === V) && o === J) && (x = U, m -= (d && L === A && A.visualViewport ? A.visualViewport.height : L[O]) - r.height, m *= c ? 1 : -1), i !== W && (i !== N && i !== U || o !== J) || (y = V, h -= (d && L === A && A.visualViewport ? A.visualViewport.width : L[k]) - r.width, h *= c ? 1 : -1);
    }
    var C,
      T = Object.assign({
        position: s
      }, l && le),
      S = !0 === p ? function (e, t) {
        var n = e.x,
          r = e.y,
          i = t.devicePixelRatio || 1;
        return {
          x: E(n * i) / i || 0,
          y: E(r * i) / i || 0
        };
      }({
        x: h,
        y: m
      }, b(n)) : {
        x: h,
        y: m
      };
    return h = S.x, m = S.y, c ? Object.assign({}, T, ((C = {})[x] = w ? "0" : "", C[y] = v ? "0" : "", C.transform = (A.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + m + "px)" : "translate3d(" + h + "px, " + m + "px, 0)", C)) : Object.assign({}, T, ((t = {})[x] = w ? m + "px" : "", t[y] = v ? h + "px" : "", t.transform = "", t));
  }
  const de = {
    name: "applyStyles",
    enabled: !0,
    phase: "write",
    fn: function (e) {
      var t = e.state;
      Object.keys(t.elements).forEach(function (e) {
        var n = t.styles[e] || {},
          r = t.attributes[e] || {},
          i = t.elements[e];
        w(i) && T(i) && (Object.assign(i.style, n), Object.keys(r).forEach(function (e) {
          var t = r[e];
          !1 === t ? i.removeAttribute(e) : i.setAttribute(e, !0 === t ? "" : t);
        }));
      });
    },
    effect: function (e) {
      var t = e.state,
        n = {
          popper: {
            position: t.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
          },
          arrow: {
            position: "absolute"
          },
          reference: {}
        };
      return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function () {
        Object.keys(t.elements).forEach(function (e) {
          var r = t.elements[e],
            i = t.attributes[e] || {},
            o = Object.keys(t.styles.hasOwnProperty(e) ? t.styles[e] : n[e]).reduce(function (e, t) {
              return e[t] = "", e;
            }, {});
          w(r) && T(r) && (Object.assign(r.style, o), Object.keys(i).forEach(function (e) {
            r.removeAttribute(e);
          }));
        });
      };
    },
    requires: ["computeStyles"]
  };
  var ue = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  };
  function he(e) {
    return e.replace(/left|right|bottom|top/g, function (e) {
      return ue[e];
    });
  }
  var fe = {
    start: "end",
    end: "start"
  };
  function me(e) {
    return e.replace(/start|end/g, function (e) {
      return fe[e];
    });
  }
  function ge(e, t) {
    var n = t.getRootNode && t.getRootNode();
    if (e.contains(t)) return !0;
    if (n && y(n)) {
      var r = t;
      do {
        if (r && e.isSameNode(r)) return !0;
        r = r.parentNode || r.host;
      } while (r);
    }
    return !1;
  }
  function be(e) {
    return Object.assign({}, e, {
      left: e.x,
      top: e.y,
      right: e.x + e.width,
      bottom: e.y + e.height
    });
  }
  function ve(e, t, n) {
    return t === Z ? be(function (e, t) {
      var n = b(e),
        r = M(e),
        i = n.visualViewport,
        o = r.clientWidth,
        a = r.clientHeight,
        s = 0,
        c = 0;
      if (i) {
        o = i.width, a = i.height;
        var l = O();
        (l || !l && "fixed" === t) && (s = i.offsetLeft, c = i.offsetTop);
      }
      return {
        width: o,
        height: a,
        x: s + S(e),
        y: c
      };
    }(e, n)) : v(t) ? function (e, t) {
      var n = k(e, !1, "fixed" === t);
      return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
    }(t, n) : be(function (e) {
      var t,
        n = M(e),
        r = C(e),
        i = null == (t = e.ownerDocument) ? void 0 : t.body,
        o = x(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0),
        a = x(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0),
        s = -r.scrollLeft + S(e),
        c = -r.scrollTop;
      return "rtl" === R(i || n).direction && (s += x(n.clientWidth, i ? i.clientWidth : 0) - o), {
        width: o,
        height: a,
        x: s,
        y: c
      };
    }(M(e)));
  }
  function we(e) {
    return Object.assign({}, {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, e);
  }
  function ye(e, t) {
    return t.reduce(function (t, n) {
      return t[n] = e, t;
    }, {});
  }
  function xe(e, t) {
    void 0 === t && (t = {});
    var n = t,
      r = n.placement,
      i = void 0 === r ? e.placement : r,
      o = n.strategy,
      a = void 0 === o ? e.strategy : o,
      s = n.boundary,
      c = void 0 === s ? "clippingParents" : s,
      l = n.rootBoundary,
      p = void 0 === l ? Z : l,
      d = n.elementContext,
      u = void 0 === d ? Y : d,
      h = n.altBoundary,
      f = void 0 !== h && h,
      m = n.padding,
      g = void 0 === m ? 0 : m,
      b = we("number" != typeof g ? g : ye(g, F)),
      y = u === Y ? "reference" : Y,
      E = e.rects.popper,
      L = e.elements[f ? y : u],
      O = function (e, t, n, r) {
        var i = "clippingParents" === t ? function (e) {
            var t = q(D(e)),
              n = ["absolute", "fixed"].indexOf(R(e).position) >= 0 && w(e) ? B(e) : e;
            return v(n) ? t.filter(function (e) {
              return v(e) && ge(e, n) && "body" !== T(e);
            }) : [];
          }(e) : [].concat(t),
          o = [].concat(i, [n]),
          a = o[0],
          s = o.reduce(function (t, n) {
            var i = ve(e, n, r);
            return t.top = x(i.top, t.top), t.right = A(i.right, t.right), t.bottom = A(i.bottom, t.bottom), t.left = x(i.left, t.left), t;
          }, ve(e, a, r));
        return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
      }(v(L) ? L : L.contextElement || M(e.elements.popper), c, p, a),
      C = k(e.elements.reference),
      S = ce({
        reference: C,
        element: E,
        strategy: "absolute",
        placement: i
      }),
      $ = be(Object.assign({}, E, S)),
      j = u === Y ? $ : C,
      H = {
        top: O.top - j.top + b.top,
        bottom: j.bottom - O.bottom + b.bottom,
        left: O.left - j.left + b.left,
        right: j.right - O.right + b.right
      },
      I = e.modifiersData.offset;
    if (u === Y && I) {
      var P = I[i];
      Object.keys(H).forEach(function (e) {
        var t = [V, U].indexOf(e) >= 0 ? 1 : -1,
          n = [N, U].indexOf(e) >= 0 ? "y" : "x";
        H[e] += P[n] * t;
      });
    }
    return H;
  }
  function Ae(e, t, n) {
    return x(e, A(t, n));
  }
  function Ee(e, t, n) {
    return void 0 === n && (n = {
      x: 0,
      y: 0
    }), {
      top: e.top - t.height - n.y,
      right: e.right - t.width + n.x,
      bottom: e.bottom - t.height + n.y,
      left: e.left - t.width - n.x
    };
  }
  function Le(e) {
    return [N, V, U, W].some(function (t) {
      return e[t] >= 0;
    });
  }
  var Oe = re({
      defaultModifiers: [{
        name: "eventListeners",
        enabled: !0,
        phase: "write",
        fn: function () {},
        effect: function (e) {
          var t = e.state,
            n = e.instance,
            r = e.options,
            i = r.scroll,
            o = void 0 === i || i,
            a = r.resize,
            s = void 0 === a || a,
            c = b(t.elements.popper),
            l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
          return o && l.forEach(function (e) {
            e.addEventListener("scroll", n.update, ie);
          }), s && c.addEventListener("resize", n.update, ie), function () {
            o && l.forEach(function (e) {
              e.removeEventListener("scroll", n.update, ie);
            }), s && c.removeEventListener("resize", n.update, ie);
          };
        },
        data: {}
      }, {
        name: "popperOffsets",
        enabled: !0,
        phase: "read",
        fn: function (e) {
          var t = e.state,
            n = e.name;
          t.modifiersData[n] = ce({
            reference: t.rects.reference,
            element: t.rects.popper,
            strategy: "absolute",
            placement: t.placement
          });
        },
        data: {}
      }, {
        name: "computeStyles",
        enabled: !0,
        phase: "beforeWrite",
        fn: function (e) {
          var t = e.state,
            n = e.options,
            r = n.gpuAcceleration,
            i = void 0 === r || r,
            o = n.adaptive,
            a = void 0 === o || o,
            s = n.roundOffsets,
            c = void 0 === s || s,
            l = {
              placement: oe(t.placement),
              variation: ae(t.placement),
              popper: t.elements.popper,
              popperRect: t.rects.popper,
              gpuAcceleration: i,
              isFixed: "fixed" === t.options.strategy
            };
          null != t.modifiersData.popperOffsets && (t.styles.popper = Object.assign({}, t.styles.popper, pe(Object.assign({}, l, {
            offsets: t.modifiersData.popperOffsets,
            position: t.options.strategy,
            adaptive: a,
            roundOffsets: c
          })))), null != t.modifiersData.arrow && (t.styles.arrow = Object.assign({}, t.styles.arrow, pe(Object.assign({}, l, {
            offsets: t.modifiersData.arrow,
            position: "absolute",
            adaptive: !1,
            roundOffsets: c
          })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
            "data-popper-placement": t.placement
          });
        },
        data: {}
      }, de, {
        name: "offset",
        enabled: !0,
        phase: "main",
        requires: ["popperOffsets"],
        fn: function (e) {
          var t = e.state,
            n = e.options,
            r = e.name,
            i = n.offset,
            o = void 0 === i ? [0, 0] : i,
            a = K.reduce(function (e, n) {
              return e[n] = function (e, t, n) {
                var r = oe(e),
                  i = [W, N].indexOf(r) >= 0 ? -1 : 1,
                  o = "function" == typeof n ? n(Object.assign({}, t, {
                    placement: e
                  })) : n,
                  a = o[0],
                  s = o[1];
                return a = a || 0, s = (s || 0) * i, [W, V].indexOf(r) >= 0 ? {
                  x: s,
                  y: a
                } : {
                  x: a,
                  y: s
                };
              }(n, t.rects, o), e;
            }, {}),
            s = a[t.placement],
            c = s.x,
            l = s.y;
          null != t.modifiersData.popperOffsets && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = a;
        }
      }, {
        name: "flip",
        enabled: !0,
        phase: "main",
        fn: function (e) {
          var t = e.state,
            n = e.options,
            r = e.name;
          if (!t.modifiersData[r]._skip) {
            for (var i = n.mainAxis, o = void 0 === i || i, a = n.altAxis, s = void 0 === a || a, c = n.fallbackPlacements, l = n.padding, p = n.boundary, d = n.rootBoundary, u = n.altBoundary, h = n.flipVariations, f = void 0 === h || h, m = n.allowedAutoPlacements, g = t.options.placement, b = oe(g), v = c || (b !== g && f ? function (e) {
                if (oe(e) === z) return [];
                var t = he(e);
                return [me(e), t, me(t)];
              }(g) : [he(g)]), w = [g].concat(v).reduce(function (e, n) {
                return e.concat(oe(n) === z ? function (e, t) {
                  void 0 === t && (t = {});
                  var n = t,
                    r = n.placement,
                    i = n.boundary,
                    o = n.rootBoundary,
                    a = n.padding,
                    s = n.flipVariations,
                    c = n.allowedAutoPlacements,
                    l = void 0 === c ? K : c,
                    p = ae(r),
                    d = p ? s ? X : X.filter(function (e) {
                      return ae(e) === p;
                    }) : F,
                    u = d.filter(function (e) {
                      return l.indexOf(e) >= 0;
                    });
                  0 === u.length && (u = d);
                  var h = u.reduce(function (t, n) {
                    return t[n] = xe(e, {
                      placement: n,
                      boundary: i,
                      rootBoundary: o,
                      padding: a
                    })[oe(n)], t;
                  }, {});
                  return Object.keys(h).sort(function (e, t) {
                    return h[e] - h[t];
                  });
                }(t, {
                  placement: n,
                  boundary: p,
                  rootBoundary: d,
                  padding: l,
                  flipVariations: f,
                  allowedAutoPlacements: m
                }) : n);
              }, []), y = t.rects.reference, x = t.rects.popper, A = new Map(), E = !0, L = w[0], O = 0; O < w.length; O++) {
              var k = w[O],
                C = oe(k),
                T = ae(k) === G,
                M = [N, U].indexOf(C) >= 0,
                S = M ? "width" : "height",
                R = xe(t, {
                  placement: k,
                  boundary: p,
                  rootBoundary: d,
                  altBoundary: u,
                  padding: l
                }),
                $ = M ? T ? V : W : T ? U : N;
              y[S] > x[S] && ($ = he($));
              var j = he($),
                H = [];
              if (o && H.push(R[C] <= 0), s && H.push(R[$] <= 0, R[j] <= 0), H.every(function (e) {
                return e;
              })) {
                L = k, E = !1;
                break;
              }
              A.set(k, H);
            }
            if (E) for (var D = function (e) {
                var t = w.find(function (t) {
                  var n = A.get(t);
                  if (n) return n.slice(0, e).every(function (e) {
                    return e;
                  });
                });
                if (t) return L = t, "break";
              }, I = f ? 3 : 1; I > 0 && "break" !== D(I); I--);
            t.placement !== L && (t.modifiersData[r]._skip = !0, t.placement = L, t.reset = !0);
          }
        },
        requiresIfExists: ["offset"],
        data: {
          _skip: !1
        }
      }, {
        name: "preventOverflow",
        enabled: !0,
        phase: "main",
        fn: function (e) {
          var t = e.state,
            n = e.options,
            r = e.name,
            i = n.mainAxis,
            o = void 0 === i || i,
            a = n.altAxis,
            s = void 0 !== a && a,
            c = n.boundary,
            l = n.rootBoundary,
            p = n.altBoundary,
            d = n.padding,
            u = n.tether,
            h = void 0 === u || u,
            f = n.tetherOffset,
            m = void 0 === f ? 0 : f,
            g = xe(t, {
              boundary: c,
              rootBoundary: l,
              padding: d,
              altBoundary: p
            }),
            b = oe(t.placement),
            v = ae(t.placement),
            w = !v,
            y = se(b),
            E = "x" === y ? "y" : "x",
            L = t.modifiersData.popperOffsets,
            O = t.rects.reference,
            k = t.rects.popper,
            C = "function" == typeof m ? m(Object.assign({}, t.rects, {
              placement: t.placement
            })) : m,
            T = "number" == typeof C ? {
              mainAxis: C,
              altAxis: C
            } : Object.assign({
              mainAxis: 0,
              altAxis: 0
            }, C),
            M = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null,
            S = {
              x: 0,
              y: 0
            };
          if (L) {
            if (o) {
              var R,
                $ = "y" === y ? N : W,
                j = "y" === y ? U : V,
                D = "y" === y ? "height" : "width",
                I = L[y],
                q = I + g[$],
                P = I - g[j],
                _ = h ? -k[D] / 2 : 0,
                z = v === G ? O[D] : k[D],
                F = v === G ? -k[D] : -O[D],
                J = t.elements.arrow,
                Z = h && J ? H(J) : {
                  width: 0,
                  height: 0
                },
                Y = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0
                },
                X = Y[$],
                K = Y[j],
                Q = Ae(0, O[D], Z[D]),
                ee = w ? O[D] / 2 - _ - Q - X - T.mainAxis : z - Q - X - T.mainAxis,
                te = w ? -O[D] / 2 + _ + Q + K + T.mainAxis : F + Q + K + T.mainAxis,
                ne = t.elements.arrow && B(t.elements.arrow),
                re = ne ? "y" === y ? ne.clientTop || 0 : ne.clientLeft || 0 : 0,
                ie = null != (R = null == M ? void 0 : M[y]) ? R : 0,
                ce = I + te - ie,
                le = Ae(h ? A(q, I + ee - ie - re) : q, I, h ? x(P, ce) : P);
              L[y] = le, S[y] = le - I;
            }
            if (s) {
              var pe,
                de = "x" === y ? N : W,
                ue = "x" === y ? U : V,
                he = L[E],
                fe = "y" === E ? "height" : "width",
                me = he + g[de],
                ge = he - g[ue],
                be = -1 !== [N, W].indexOf(b),
                ve = null != (pe = null == M ? void 0 : M[E]) ? pe : 0,
                we = be ? me : he - O[fe] - k[fe] - ve + T.altAxis,
                ye = be ? he + O[fe] + k[fe] - ve - T.altAxis : ge,
                Ee = h && be ? function (e, t, n) {
                  var r = Ae(e, t, n);
                  return r > n ? n : r;
                }(we, he, ye) : Ae(h ? we : me, he, h ? ye : ge);
              L[E] = Ee, S[E] = Ee - he;
            }
            t.modifiersData[r] = S;
          }
        },
        requiresIfExists: ["offset"]
      }, {
        name: "arrow",
        enabled: !0,
        phase: "main",
        fn: function (e) {
          var t,
            n = e.state,
            r = e.name,
            i = e.options,
            o = n.elements.arrow,
            a = n.modifiersData.popperOffsets,
            s = oe(n.placement),
            c = se(s),
            l = [W, V].indexOf(s) >= 0 ? "height" : "width";
          if (o && a) {
            var p = function (e, t) {
                return we("number" != typeof (e = "function" == typeof e ? e(Object.assign({}, t.rects, {
                  placement: t.placement
                })) : e) ? e : ye(e, F));
              }(i.padding, n),
              d = H(o),
              u = "y" === c ? N : W,
              h = "y" === c ? U : V,
              f = n.rects.reference[l] + n.rects.reference[c] - a[c] - n.rects.popper[l],
              m = a[c] - n.rects.reference[c],
              g = B(o),
              b = g ? "y" === c ? g.clientHeight || 0 : g.clientWidth || 0 : 0,
              v = f / 2 - m / 2,
              w = p[u],
              y = b - d[l] - p[h],
              x = b / 2 - d[l] / 2 + v,
              A = Ae(w, x, y),
              E = c;
            n.modifiersData[r] = ((t = {})[E] = A, t.centerOffset = A - x, t);
          }
        },
        effect: function (e) {
          var t = e.state,
            n = e.options.element,
            r = void 0 === n ? "[data-popper-arrow]" : n;
          null != r && ("string" != typeof r || (r = t.elements.popper.querySelector(r))) && ge(t.elements.popper, r) && (t.elements.arrow = r);
        },
        requires: ["popperOffsets"],
        requiresIfExists: ["preventOverflow"]
      }, {
        name: "hide",
        enabled: !0,
        phase: "main",
        requiresIfExists: ["preventOverflow"],
        fn: function (e) {
          var t = e.state,
            n = e.name,
            r = t.rects.reference,
            i = t.rects.popper,
            o = t.modifiersData.preventOverflow,
            a = xe(t, {
              elementContext: "reference"
            }),
            s = xe(t, {
              altBoundary: !0
            }),
            c = Ee(a, r),
            l = Ee(s, i, o),
            p = Le(c),
            d = Le(l);
          t.modifiersData[n] = {
            referenceClippingOffsets: c,
            popperEscapeOffsets: l,
            isReferenceHidden: p,
            hasPopperEscaped: d
          }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
            "data-popper-reference-hidden": p,
            "data-popper-escaped": d
          });
        }
      }]
    }),
    ke = "tippy-content",
    Ce = "tippy-arrow",
    Te = "tippy-svg-arrow",
    Me = {
      passive: !0,
      capture: !0
    },
    Se = function () {
      return document.body;
    };
  function Re(e, t, n) {
    if (Array.isArray(e)) {
      var r = e[t];
      return null == r ? Array.isArray(n) ? n[t] : n : r;
    }
    return e;
  }
  function $e(e, t) {
    var n = {}.toString.call(e);
    return 0 === n.indexOf("[object") && n.indexOf(t + "]") > -1;
  }
  function je(e, t) {
    return "function" == typeof e ? e.apply(void 0, t) : e;
  }
  function He(e, t) {
    return 0 === t ? e : function (r) {
      clearTimeout(n), n = setTimeout(function () {
        e(r);
      }, t);
    };
    var n;
  }
  function De(e) {
    return [].concat(e);
  }
  function Ie(e, t) {
    -1 === e.indexOf(t) && e.push(t);
  }
  function qe(e) {
    return [].slice.call(e);
  }
  function Pe(e) {
    return Object.keys(e).reduce(function (t, n) {
      return void 0 !== e[n] && (t[n] = e[n]), t;
    }, {});
  }
  function _e() {
    return document.createElement("div");
  }
  function Be(e) {
    return ["Element", "Fragment"].some(function (t) {
      return $e(e, t);
    });
  }
  function Ne(e, t) {
    e.forEach(function (e) {
      e && (e.style.transitionDuration = t + "ms");
    });
  }
  function Ue(e, t) {
    e.forEach(function (e) {
      e && e.setAttribute("data-state", t);
    });
  }
  function Ve(e, t, n) {
    var r = t + "EventListener";
    ["transitionend", "webkitTransitionEnd"].forEach(function (t) {
      e[r](t, n);
    });
  }
  function We(e, t) {
    for (var n = t; n;) {
      var r;
      if (e.contains(n)) return !0;
      n = null == n.getRootNode || null == (r = n.getRootNode()) ? void 0 : r.host;
    }
    return !1;
  }
  var ze = {
      isTouch: !1
    },
    Fe = 0;
  function Ge() {
    ze.isTouch || (ze.isTouch = !0, window.performance && document.addEventListener("mousemove", Je));
  }
  function Je() {
    var e = performance.now();
    e - Fe < 20 && (ze.isTouch = !1, document.removeEventListener("mousemove", Je)), Fe = e;
  }
  function Ze() {
    var e,
      t = document.activeElement;
    if ((e = t) && e._tippy && e._tippy.reference === e) {
      var n = t._tippy;
      t.blur && !n.state.isVisible && t.blur();
    }
  }
  var Ye = !("undefined" == typeof window || "undefined" == typeof document || !window.msCrypto),
    Xe = Object.assign({
      appendTo: Se,
      aria: {
        content: "auto",
        expanded: "auto"
      },
      delay: 0,
      duration: [300, 250],
      getReferenceClientRect: null,
      hideOnClick: !0,
      ignoreAttributes: !1,
      interactive: !1,
      interactiveBorder: 2,
      interactiveDebounce: 0,
      moveTransition: "",
      offset: [0, 10],
      onAfterUpdate: function () {},
      onBeforeUpdate: function () {},
      onCreate: function () {},
      onDestroy: function () {},
      onHidden: function () {},
      onHide: function () {},
      onMount: function () {},
      onShow: function () {},
      onShown: function () {},
      onTrigger: function () {},
      onUntrigger: function () {},
      onClickOutside: function () {},
      placement: "top",
      plugins: [],
      popperOptions: {},
      render: null,
      showOnCreate: !1,
      touch: !0,
      trigger: "mouseenter focus",
      triggerTarget: null
    }, {
      animateFill: !1,
      followCursor: !1,
      inlinePositioning: !1,
      sticky: !1
    }, {
      allowHTML: !1,
      animation: "fade",
      arrow: !0,
      content: "",
      inertia: !1,
      maxWidth: 350,
      role: "tooltip",
      theme: "",
      zIndex: 9999
    }),
    Ke = Object.keys(Xe);
  function Qe(e) {
    var t = (e.plugins || []).reduce(function (t, n) {
      var r,
        i = n.name,
        o = n.defaultValue;
      return i && (t[i] = void 0 !== e[i] ? e[i] : null != (r = Xe[i]) ? r : o), t;
    }, {});
    return Object.assign({}, e, t);
  }
  function et(e, t) {
    var n = Object.assign({}, t, {
      content: je(t.content, [e])
    }, t.ignoreAttributes ? {} : function (e, t) {
      return (t ? Object.keys(Qe(Object.assign({}, Xe, {
        plugins: t
      }))) : Ke).reduce(function (t, n) {
        var r = (e.getAttribute("data-tippy-" + n) || "").trim();
        if (!r) return t;
        if ("content" === n) t[n] = r;else try {
          t[n] = JSON.parse(r);
        } catch (e) {
          t[n] = r;
        }
        return t;
      }, {});
    }(e, t.plugins));
    return n.aria = Object.assign({}, Xe.aria, n.aria), n.aria = {
      expanded: "auto" === n.aria.expanded ? t.interactive : n.aria.expanded,
      content: "auto" === n.aria.content ? t.interactive ? null : "describedby" : n.aria.content
    }, n;
  }
  function tt(e, t) {
    e.innerHTML = t;
  }
  function nt(e) {
    var t = _e();
    return !0 === e ? t.className = Ce : (t.className = Te, Be(e) ? t.appendChild(e) : tt(t, e)), t;
  }
  function rt(e, t) {
    Be(t.content) ? (tt(e, ""), e.appendChild(t.content)) : "function" != typeof t.content && (t.allowHTML ? tt(e, t.content) : e.textContent = t.content);
  }
  function it(e) {
    var t = e.firstElementChild,
      n = qe(t.children);
    return {
      box: t,
      content: n.find(function (e) {
        return e.classList.contains(ke);
      }),
      arrow: n.find(function (e) {
        return e.classList.contains(Ce) || e.classList.contains(Te);
      }),
      backdrop: n.find(function (e) {
        return e.classList.contains("tippy-backdrop");
      })
    };
  }
  function ot(e) {
    var t = _e(),
      n = _e();
    n.className = "tippy-box", n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
    var r = _e();
    function i(n, r) {
      var i = it(t),
        o = i.box,
        a = i.content,
        s = i.arrow;
      r.theme ? o.setAttribute("data-theme", r.theme) : o.removeAttribute("data-theme"), "string" == typeof r.animation ? o.setAttribute("data-animation", r.animation) : o.removeAttribute("data-animation"), r.inertia ? o.setAttribute("data-inertia", "") : o.removeAttribute("data-inertia"), o.style.maxWidth = "number" == typeof r.maxWidth ? r.maxWidth + "px" : r.maxWidth, r.role ? o.setAttribute("role", r.role) : o.removeAttribute("role"), n.content === r.content && n.allowHTML === r.allowHTML || rt(a, e.props), r.arrow ? s ? n.arrow !== r.arrow && (o.removeChild(s), o.appendChild(nt(r.arrow))) : o.appendChild(nt(r.arrow)) : s && o.removeChild(s);
    }
    return r.className = ke, r.setAttribute("data-state", "hidden"), rt(r, e.props), t.appendChild(n), n.appendChild(r), i(e.props, e.props), {
      popper: t,
      onUpdate: i
    };
  }
  ot.$$tippy = !0;
  var at = 1,
    st = [],
    ct = [];
  function lt(e, t) {
    var n,
      r,
      i,
      o,
      a,
      s,
      c,
      l,
      p = et(e, Object.assign({}, Xe, Qe(Pe(t)))),
      d = !1,
      u = !1,
      h = !1,
      f = !1,
      m = [],
      g = He(G, p.interactiveDebounce),
      b = at++,
      v = (l = p.plugins).filter(function (e, t) {
        return l.indexOf(e) === t;
      }),
      w = {
        id: b,
        reference: e,
        popper: _e(),
        popperInstance: null,
        props: p,
        state: {
          isEnabled: !0,
          isVisible: !1,
          isDestroyed: !1,
          isMounted: !1,
          isShown: !1
        },
        plugins: v,
        clearDelayTimeouts: function () {
          clearTimeout(n), clearTimeout(r), cancelAnimationFrame(i);
        },
        setProps: function (t) {
          if (!w.state.isDestroyed) {
            j("onBeforeUpdate", [w, t]), z();
            var n = w.props,
              r = et(e, Object.assign({}, n, Pe(t), {
                ignoreAttributes: !0
              }));
            w.props = r, W(), n.interactiveDebounce !== r.interactiveDebounce && (I(), g = He(G, r.interactiveDebounce)), n.triggerTarget && !r.triggerTarget ? De(n.triggerTarget).forEach(function (e) {
              e.removeAttribute("aria-expanded");
            }) : r.triggerTarget && e.removeAttribute("aria-expanded"), D(), $(), A && A(n, r), w.popperInstance && (X(), Q().forEach(function (e) {
              requestAnimationFrame(e._tippy.popperInstance.forceUpdate);
            })), j("onAfterUpdate", [w, t]);
          }
        },
        setContent: function (e) {
          w.setProps({
            content: e
          });
        },
        show: function () {
          var e = w.state.isVisible,
            t = w.state.isDestroyed,
            n = !w.state.isEnabled,
            r = ze.isTouch && !w.props.touch,
            i = Re(w.props.duration, 0, Xe.duration);
          if (!(e || t || n || r || T().hasAttribute("disabled") || (j("onShow", [w], !1), !1 === w.props.onShow(w)))) {
            if (w.state.isVisible = !0, C() && (x.style.visibility = "visible"), $(), B(), w.state.isMounted || (x.style.transition = "none"), C()) {
              var o = S();
              Ne([o.box, o.content], 0);
            }
            var a, c, l;
            s = function () {
              var e;
              if (w.state.isVisible && !f) {
                if (f = !0, x.offsetHeight, x.style.transition = w.props.moveTransition, C() && w.props.animation) {
                  var t = S(),
                    n = t.box,
                    r = t.content;
                  Ne([n, r], i), Ue([n, r], "visible");
                }
                H(), D(), Ie(ct, w), null == (e = w.popperInstance) || e.forceUpdate(), j("onMount", [w]), w.props.animation && C() && function (e) {
                  U(e, function () {
                    w.state.isShown = !0, j("onShown", [w]);
                  });
                }(i);
              }
            }, c = w.props.appendTo, l = T(), (a = w.props.interactive && c === Se || "parent" === c ? l.parentNode : je(c, [l])).contains(x) || a.appendChild(x), w.state.isMounted = !0, X();
          }
        },
        hide: function () {
          var e = !w.state.isVisible,
            t = w.state.isDestroyed,
            n = !w.state.isEnabled,
            r = Re(w.props.duration, 1, Xe.duration);
          if (!(e || t || n) && (j("onHide", [w], !1), !1 !== w.props.onHide(w))) {
            if (w.state.isVisible = !1, w.state.isShown = !1, f = !1, d = !1, C() && (x.style.visibility = "hidden"), I(), N(), $(!0), C()) {
              var i = S(),
                o = i.box,
                a = i.content;
              w.props.animation && (Ne([o, a], r), Ue([o, a], "hidden"));
            }
            H(), D(), w.props.animation ? C() && function (e, t) {
              U(e, function () {
                !w.state.isVisible && x.parentNode && x.parentNode.contains(x) && t();
              });
            }(r, w.unmount) : w.unmount();
          }
        },
        hideWithInteractivity: function (e) {
          M().addEventListener("mousemove", g), Ie(st, g), g(e);
        },
        enable: function () {
          w.state.isEnabled = !0;
        },
        disable: function () {
          w.hide(), w.state.isEnabled = !1;
        },
        unmount: function () {
          w.state.isVisible && w.hide(), w.state.isMounted && (K(), Q().forEach(function (e) {
            e._tippy.unmount();
          }), x.parentNode && x.parentNode.removeChild(x), ct = ct.filter(function (e) {
            return e !== w;
          }), w.state.isMounted = !1, j("onHidden", [w]));
        },
        destroy: function () {
          w.state.isDestroyed || (w.clearDelayTimeouts(), w.unmount(), z(), delete e._tippy, w.state.isDestroyed = !0, j("onDestroy", [w]));
        }
      };
    if (!p.render) return w;
    var y = p.render(w),
      x = y.popper,
      A = y.onUpdate;
    x.setAttribute("data-tippy-root", ""), x.id = "tippy-" + w.id, w.popper = x, e._tippy = w, x._tippy = w;
    var E = v.map(function (e) {
        return e.fn(w);
      }),
      L = e.hasAttribute("aria-expanded");
    return W(), D(), $(), j("onCreate", [w]), p.showOnCreate && ee(), x.addEventListener("mouseenter", function () {
      w.props.interactive && w.state.isVisible && w.clearDelayTimeouts();
    }), x.addEventListener("mouseleave", function () {
      w.props.interactive && w.props.trigger.indexOf("mouseenter") >= 0 && M().addEventListener("mousemove", g);
    }), w;
    function O() {
      var e = w.props.touch;
      return Array.isArray(e) ? e : [e, 0];
    }
    function k() {
      return "hold" === O()[0];
    }
    function C() {
      var e;
      return !(null == (e = w.props.render) || !e.$$tippy);
    }
    function T() {
      return c || e;
    }
    function M() {
      var e,
        t,
        n = T().parentNode;
      return n ? null != (t = De(n)[0]) && null != (e = t.ownerDocument) && e.body ? t.ownerDocument : document : document;
    }
    function S() {
      return it(x);
    }
    function R(e) {
      return w.state.isMounted && !w.state.isVisible || ze.isTouch || o && "focus" === o.type ? 0 : Re(w.props.delay, e ? 0 : 1, Xe.delay);
    }
    function $(e) {
      void 0 === e && (e = !1), x.style.pointerEvents = w.props.interactive && !e ? "" : "none", x.style.zIndex = "" + w.props.zIndex;
    }
    function j(e, t, n) {
      var r;
      void 0 === n && (n = !0), E.forEach(function (n) {
        n[e] && n[e].apply(n, t);
      }), n && (r = w.props)[e].apply(r, t);
    }
    function H() {
      var t = w.props.aria;
      if (t.content) {
        var n = "aria-" + t.content,
          r = x.id;
        De(w.props.triggerTarget || e).forEach(function (e) {
          var t = e.getAttribute(n);
          if (w.state.isVisible) e.setAttribute(n, t ? t + " " + r : r);else {
            var i = t && t.replace(r, "").trim();
            i ? e.setAttribute(n, i) : e.removeAttribute(n);
          }
        });
      }
    }
    function D() {
      !L && w.props.aria.expanded && De(w.props.triggerTarget || e).forEach(function (e) {
        w.props.interactive ? e.setAttribute("aria-expanded", w.state.isVisible && e === T() ? "true" : "false") : e.removeAttribute("aria-expanded");
      });
    }
    function I() {
      M().removeEventListener("mousemove", g), st = st.filter(function (e) {
        return e !== g;
      });
    }
    function q(t) {
      if (!ze.isTouch || !h && "mousedown" !== t.type) {
        var n = t.composedPath && t.composedPath()[0] || t.target;
        if (!w.props.interactive || !We(x, n)) {
          if (De(w.props.triggerTarget || e).some(function (e) {
            return We(e, n);
          })) {
            if (ze.isTouch) return;
            if (w.state.isVisible && w.props.trigger.indexOf("click") >= 0) return;
          } else j("onClickOutside", [w, t]);
          !0 === w.props.hideOnClick && (w.clearDelayTimeouts(), w.hide(), u = !0, setTimeout(function () {
            u = !1;
          }), w.state.isMounted || N());
        }
      }
    }
    function P() {
      h = !0;
    }
    function _() {
      h = !1;
    }
    function B() {
      var e = M();
      e.addEventListener("mousedown", q, !0), e.addEventListener("touchend", q, Me), e.addEventListener("touchstart", _, Me), e.addEventListener("touchmove", P, Me);
    }
    function N() {
      var e = M();
      e.removeEventListener("mousedown", q, !0), e.removeEventListener("touchend", q, Me), e.removeEventListener("touchstart", _, Me), e.removeEventListener("touchmove", P, Me);
    }
    function U(e, t) {
      var n = S().box;
      function r(e) {
        e.target === n && (Ve(n, "remove", r), t());
      }
      if (0 === e) return t();
      Ve(n, "remove", a), Ve(n, "add", r), a = r;
    }
    function V(t, n, r) {
      void 0 === r && (r = !1), De(w.props.triggerTarget || e).forEach(function (e) {
        e.addEventListener(t, n, r), m.push({
          node: e,
          eventType: t,
          handler: n,
          options: r
        });
      });
    }
    function W() {
      var e;
      k() && (V("touchstart", F, {
        passive: !0
      }), V("touchend", J, {
        passive: !0
      })), (e = w.props.trigger, e.split(/\s+/).filter(Boolean)).forEach(function (e) {
        if ("manual" !== e) switch (V(e, F), e) {
          case "mouseenter":
            V("mouseleave", J);
            break;
          case "focus":
            V(Ye ? "focusout" : "blur", Z);
            break;
          case "focusin":
            V("focusout", Z);
        }
      });
    }
    function z() {
      m.forEach(function (e) {
        var t = e.node,
          n = e.eventType,
          r = e.handler,
          i = e.options;
        t.removeEventListener(n, r, i);
      }), m = [];
    }
    function F(e) {
      var t,
        n = !1;
      if (w.state.isEnabled && !Y(e) && !u) {
        var r = "focus" === (null == (t = o) ? void 0 : t.type);
        o = e, c = e.currentTarget, D(), !w.state.isVisible && $e(e, "MouseEvent") && st.forEach(function (t) {
          return t(e);
        }), "click" === e.type && (w.props.trigger.indexOf("mouseenter") < 0 || d) && !1 !== w.props.hideOnClick && w.state.isVisible ? n = !0 : ee(e), "click" === e.type && (d = !n), n && !r && te(e);
      }
    }
    function G(e) {
      var t = e.target,
        n = T().contains(t) || x.contains(t);
      if ("mousemove" !== e.type || !n) {
        var r = Q().concat(x).map(function (e) {
          var t,
            n = null == (t = e._tippy.popperInstance) ? void 0 : t.state;
          return n ? {
            popperRect: e.getBoundingClientRect(),
            popperState: n,
            props: p
          } : null;
        }).filter(Boolean);
        (function (e, t) {
          var n = t.clientX,
            r = t.clientY;
          return e.every(function (e) {
            var t = e.popperRect,
              i = e.popperState,
              o = e.props.interactiveBorder,
              a = i.placement.split("-")[0],
              s = i.modifiersData.offset;
            if (!s) return !0;
            var c = "bottom" === a ? s.top.y : 0,
              l = "top" === a ? s.bottom.y : 0,
              p = "right" === a ? s.left.x : 0,
              d = "left" === a ? s.right.x : 0,
              u = t.top - r + c > o,
              h = r - t.bottom - l > o,
              f = t.left - n + p > o,
              m = n - t.right - d > o;
            return u || h || f || m;
          });
        })(r, e) && (I(), te(e));
      }
    }
    function J(e) {
      Y(e) || w.props.trigger.indexOf("click") >= 0 && d || (w.props.interactive ? w.hideWithInteractivity(e) : te(e));
    }
    function Z(e) {
      w.props.trigger.indexOf("focusin") < 0 && e.target !== T() || w.props.interactive && e.relatedTarget && x.contains(e.relatedTarget) || te(e);
    }
    function Y(e) {
      return !!ze.isTouch && k() !== e.type.indexOf("touch") >= 0;
    }
    function X() {
      K();
      var t = w.props,
        n = t.popperOptions,
        r = t.placement,
        i = t.offset,
        o = t.getReferenceClientRect,
        a = t.moveTransition,
        c = C() ? it(x).arrow : null,
        l = o ? {
          getBoundingClientRect: o,
          contextElement: o.contextElement || T()
        } : e,
        p = [{
          name: "offset",
          options: {
            offset: i
          }
        }, {
          name: "preventOverflow",
          options: {
            padding: {
              top: 2,
              bottom: 2,
              left: 5,
              right: 5
            }
          }
        }, {
          name: "flip",
          options: {
            padding: 5
          }
        }, {
          name: "computeStyles",
          options: {
            adaptive: !a
          }
        }, {
          name: "$$tippy",
          enabled: !0,
          phase: "beforeWrite",
          requires: ["computeStyles"],
          fn: function (e) {
            var t = e.state;
            if (C()) {
              var n = S().box;
              ["placement", "reference-hidden", "escaped"].forEach(function (e) {
                "placement" === e ? n.setAttribute("data-placement", t.placement) : t.attributes.popper["data-popper-" + e] ? n.setAttribute("data-" + e, "") : n.removeAttribute("data-" + e);
              }), t.attributes.popper = {};
            }
          }
        }];
      C() && c && p.push({
        name: "arrow",
        options: {
          element: c,
          padding: 3
        }
      }), p.push.apply(p, (null == n ? void 0 : n.modifiers) || []), w.popperInstance = Oe(l, x, Object.assign({}, n, {
        placement: r,
        onFirstUpdate: s,
        modifiers: p
      }));
    }
    function K() {
      w.popperInstance && (w.popperInstance.destroy(), w.popperInstance = null);
    }
    function Q() {
      return qe(x.querySelectorAll("[data-tippy-root]"));
    }
    function ee(e) {
      w.clearDelayTimeouts(), e && j("onTrigger", [w, e]), B();
      var t = R(!0),
        r = O(),
        i = r[0],
        o = r[1];
      ze.isTouch && "hold" === i && o && (t = o), t ? n = setTimeout(function () {
        w.show();
      }, t) : w.show();
    }
    function te(e) {
      if (w.clearDelayTimeouts(), j("onUntrigger", [w, e]), w.state.isVisible) {
        if (!(w.props.trigger.indexOf("mouseenter") >= 0 && w.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(e.type) >= 0 && d)) {
          var t = R(!1);
          t ? r = setTimeout(function () {
            w.state.isVisible && w.hide();
          }, t) : i = requestAnimationFrame(function () {
            w.hide();
          });
        }
      } else N();
    }
  }
  function pt(e, t) {
    void 0 === t && (t = {});
    var n = Xe.plugins.concat(t.plugins || []);
    document.addEventListener("touchstart", Ge, Me), window.addEventListener("blur", Ze);
    var r,
      i = Object.assign({}, t, {
        plugins: n
      }),
      o = (r = e, Be(r) ? [r] : function (e) {
        return $e(e, "NodeList");
      }(r) ? qe(r) : Array.isArray(r) ? r : qe(document.querySelectorAll(r))).reduce(function (e, t) {
        var n = t && lt(t, i);
        return n && e.push(n), e;
      }, []);
    return Be(e) ? o[0] : o;
  }
  pt.defaultProps = Xe, pt.setDefaultProps = function (e) {
    Object.keys(e).forEach(function (t) {
      Xe[t] = e[t];
    });
  }, pt.currentInput = ze, Object.assign({}, de, {
    effect: function (e) {
      var t = e.state,
        n = {
          popper: {
            position: t.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
          },
          arrow: {
            position: "absolute"
          },
          reference: {}
        };
      Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow);
    }
  }), pt.setDefaultProps({
    render: ot
  });
  const dt = pt,
    ut = document.createElement("template");
  class ht extends HTMLElement {
    constructor() {
      var e;
      super(), this.rheaURL = this.hasAttribute("usehost") ? this.getAttribute("usehost") : o, this.imageHost = this.hasAttribute("imagehost") ? this.getAttribute("imagehost") : this.rheaURL, this.shownewchebi = this.hasAttribute("shownewchebi"), this.reactiontab = this.hasAttribute("reactiontab"), this._reaction = {}, this.noTooltips = this.hasAttribute("notooltips"), this._rheaid = "", this._options = {
        showids: this.hasAttribute("showids"),
        usehost: this.rheaURL,
        imagehost: this.imageHost,
        shownewchebi: this.shownewchebi,
        nosource: this.hasAttribute("nosource")
      }, this.shadow = this.attachShadow({
        mode: "open"
      }), this.shadow.appendChild((e = this._options, ut.innerHTML = `\n  <style class="nativestyle">\n  ${g.A}\n  </style>\n  <div class="rhea-reaction-visualizer">\n      <div class="tabs">\n          <div class="tab" data-related="reaction">Reaction</div>\n          <div class="tab selected" data-related="atommap">Atom map</div>\n      </div>\n      <div class="tabpanel reaction">\n          <rhea-reaction ${e.shownewchebi ? "shownewchebi" : ""} ${e.showids ? "showids" : ""} ${e.nosource ? "nosource" : ""} usehost="${e.usehost}" zoom imagehost="${e.imagehost}"></rhea-reaction>\n      </div>\n      <div class="tabpanel atommap selected">\n          <rhea-atommap ${e.nosource ? "nosource" : ""} usehost="${e.usehost}" ${e.showids ? "showids" : ""} imagehost="${e.imagehost}"></rhea-atommap>\n      </div>\n  </div>\n  `, ut).content.cloneNode(!0)), this.wrapper = this.shadow.querySelector(".rhea-reaction-visualizer"), this.atommap = this.wrapper.querySelector("rhea-atommap"), this.rheareaction = this.wrapper.querySelector("rhea-reaction");
    }
    get reaction() {
      return this._reaction;
    }
    set reaction(e) {
      this._reaction = e, this.render(e);
    }
    set rheaid(e) {
      this._rheaid = e, this.renderWithId(e);
    }
    get rheaid() {
      return this._rheaid;
    }
    attributeChangedCallback(e, t, n) {
      if (t !== n) switch (e) {
        case "rheaid":
          let e = n.toLowerCase();
          e.startsWith("rhea:") && (e = e.subString(5)), this.renderWithId(e);
          break;
        case "styleid":
          let t = this.shadowRoot.querySelector(".customstyle");
          if (t && t.remove(), "" == n.trim()) return;
          let r = document.querySelector("#" + n);
          if (r) {
            let e = this.shadowRoot.querySelector(".nativestyle");
            e.insertAdjacentHTML("afterend", r.innerHTML), e.nextElementSibling.setAttribute("class", "customstyle");
          }
      }
    }
    static get observedAttributes() {
      return ["rheaid", "styleid"];
    }
    async renderWithId(e) {
      try {
        let t = await fetch(`${this.rheaURL}/rhea/${e}/json`);
        this.reaction = await t.json();
      } catch (e) {
        console.error(`Error fetching reaction data from ${this.rheaURL}`, e), this.reaction = {};
      }
    }
    async render(e) {
      this._rheaid = e.id, this.atommap.reaction = e, this.rheareaction.reaction = e;
    }
    connectedCallback() {
      let e = this.wrapper;
      Array.from(e.querySelectorAll(".tab")).forEach(t => {
        t.addEventListener("click", t => {
          if (t.target.classList.contains("selected")) return;
          e.querySelector(".tab.selected").classList.remove("selected"), t.target.classList.add("selected");
          let n = t.target.getAttribute("data-related");
          e.querySelector(".tabpanel.selected").classList.remove("selected"), e.querySelector(".tabpanel." + n).classList.add("selected"), "atommap" == n && this.atommap.reRenderSVG();
        });
      }), this.addRerenderDuetoWindowResize(e), this.shadowRoot.addEventListener("rendered-rhea-reaction", e => {
        this.noTooltips || this.addToolTips(this.rheareaction), console.log("Reaction rendered");
      }), this.shadowRoot.addEventListener("rendered-rhea-atommap", e => {
        "" == e.detail.error ? (!e.detail.reRender && this.reactiontab && this.wrapper.querySelector(".tab[data-related=reaction]").click(), this.adjustHeightOfPanel(), this.noTooltips || this.addToolTips(this.atommap), this.addAtomMapInfoToolTip(this.atommap), console.log("Reaction atommap rendered")) : e.detail.reRender || this.wrapper.querySelector(".tab[data-related=reaction]").click();
      });
    }
    addRerenderDuetoWindowResize(e) {
      let t = -1;
      window.addEventListener("resize", n => {
        e.querySelector(".tabpanel.selected.atommap") && (clearTimeout(t), t = setTimeout(e => {
          console.log("rerending due to window resize"), this.atommap.reRenderSVG();
        }, 250));
      });
    }
    adjustHeightOfPanel() {
      let e = this.shadowRoot.querySelector("rhea-atommap").getBoundingClientRect().height;
      this.shadowRoot.querySelector(".tabpanel.atommap").style.height = e + 100 + "px";
    }
    addAtomMapInfoToolTip(e) {
      dt(e.querySelector(".info"), {
        content: '<div xmlns="http://www.w3.org/1999/xhtml">\n                                    <p>The atom map of a reaction shows, for each non-hydrogen atom in the reactant, the corresponding atom in the product. This correspondence is illustrated using matching colors for the atoms and bonds and/or numbers labeling the atoms.</p>\n\n<p>The atom mapping is performed with an unsupervised transformer encoder model (<a href="https://doi.org/10.1126/sciadv.abe4166">RXNMapper</a>) that assigns a confidence score between 0-1 (low - high confidence) to each map.</p>\n                                </div>'.split("\n").join(""),
        allowHTML: !0,
        trigger: "click",
        theme: "material",
        interactive: !0,
        placement: "top-start",
        maxWidth: "400px"
      });
    }
    addToolTips(e) {
      Array.from(e.querySelectorAll(".more[data-id]")).forEach(e => {
        let t = e.getAttribute("data-id");
        dt(e, {
          content: l(t, this.rheaURL),
          allowHTML: !0,
          trigger: "click",
          theme: "material",
          interactive: !0,
          placement: "top-end",
          maxWidth: "max-content"
        });
      });
    }
  }
  window.customElements.get("rhea-reaction-block") || window.customElements.define("rhea-reaction-block", h), window.customElements.get("rhea-reaction") || window.customElements.define("rhea-reaction", u), window.customElements.get("rhea-atommap") || window.customElements.define("rhea-atommap", m), window.customElements.get("rhea-visualizer") || window.customElements.define("rhea-visualizer", ht);
})();